<footer>
  <div class='small mx-auto d-inline-block'>
    <div *ngIf="i18nLangService.hasTranslationKey('emailFooter')" [innerHTML]="'emailFooter' | translate"></div>
    <div>{{ 'adn.releaseId' | translate: { id: version } }}</div>
    <div>{{ 'adn.copyright' | translate }}</div>
  </div>
</footer>
